<script setup lang="ts">
interface InputRowProps {
  label: string;
  modelValue: string;
  placeholder?: string;
  maxLength?: number;
  readonly?: boolean;
}

const props = withDefaults(defineProps<InputRowProps>(), {
  placeholder: '',
  modelValue: '',
  maxLength: 100,
  readonly: false,
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();
</script>

<template>
  <div class="flex flex-col w-full justify-center gap-2">
    <p class="text-[15px] text-[#757575] font-normal mb-0">{{ label }}</p>
    <input
      :value="modelValue"
      :placeholder="props.placeholder"
      :maxlength="props.maxLength"
      :readonly="props.readonly"
      @input="e => emit('update:modelValue', (e.target as HTMLInputElement).value)"
      class="w-full h-[54px] text-[16px] text-[#404040] font-normal border border-[#EAEAEA] rounded-[6px] px-[18px] py-[14px]"
    />
  </div>
</template>
